module.exports = __webpack_public_path__ + "02_mustache_silver.c60aceab.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer3/02_mustache_silver.png
// module id = Np1n
// module chunks = 0